import {NgbDateStruct}                  from "@ng-bootstrap/ng-bootstrap";
export class CommonUtility {
    public ConvertDateStringToNgbDate(dateString: string): NgbDateStruct {
        let date = new Date(dateString);
        if (date) {
            let dateToConvert: NgbDateStruct = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()};
            return dateToConvert;
        }
        return null;
    }

    public ConvertLocalDateToUTCDate(localDate: any): Date {
        if (!localDate) return null;
        // in case the type of localDate isn't Date type, we pass it in to a new Date instance to make sure
        // we can retrieve it's fullyear, month and date properties.
        let dtLocal = new Date(localDate);
        let utcDate = new Date(Date.UTC(dtLocal.getFullYear(), dtLocal.getMonth(), dtLocal.getDate()));
        return utcDate;
    }
} 


// WEBPACK FOOTER //
// ./src/app/utils/commonUtility.ts